<template>
    <div class="center">
      <vue-core-image-upload
          inputOfFile = "image"
          extensions = "png,jpg,gif"
          class="button"
          :text = "text"
          crop="local"
          cropRatio = "1:1"
          :maxWidth = 500
          :maxHeight = 500
          @imageuploaded="imageuploaded"
          :max-file-size="5242880"
          :url=url >
      </vue-core-image-upload>
      <figure v-if="image" class="image is-128x128 mt-4">
        <img :src="image">
      </figure>
    </div>
</template>

<script>

// Image widget documentation: https://www.npmjs.com/package/vue-core-image-upload

import VueCoreImageUpload from 'vue-core-image-upload'
import { FOOSHI_API_URL } from '../.env'
import { FooshiApi } from '@/services/fooshiApi.service'

export default {
  name: 'ImageUpload',
  components: {
    'vue-core-image-upload': VueCoreImageUpload
  },
  props: {
    edit: Boolean,
    id: Number
  },
  watch: {
    async id (newId, oldId) {
      await this.fetchImage()
    }
  },
  data () {
    return {
      url: FOOSHI_API_URL + 'product-image',
      image: '',
      text: this.$t('app.buttons.uploadImage')
    }
  },
  methods: {
    async imageuploaded (res) {
      this.$emit('image-uploaded', res.imageId)
      this.image = 'data:image/jpeg;base64,' + btoa(new Uint8Array(res.image.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))
      this.text = 'Change Image'
    },
    async fetchImage () {
      if (this.edit && this.id) {
        const response = await FooshiApi.getProductImage(this.id)
        this.image = 'data:image/jpeg;base64,' + btoa(new Uint8Array(response.data.image.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))
        this.text = 'Change Image'
      }
    }
  },
  async mounted () {
    await this.fetchImage()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ImageUpload.vue